import Util from '../../lib/util';
import { Store, Module, ActionContext } from 'vuex'
import ajax from '../../lib/ajax'
import { eventBus } from '@/lib/eventbus'
import tools from "@/lib/tools"
import appConst from "@/lib/appconst"
import {AppStateBase,INPUT_WIN_PARAM,openWinCom} from "./mod-com"

interface AppState extends AppStateBase {
    files:Array<object> //缓存的临时文件
}

class AppModule implements Module<AppState, any>{
    namespaced = true;
    self = this;
    state = {
        files:[]
    };
    mutations = {
        setFiles(state,files){
            state.files = files;
        }
    }
    actions = {

    }
}
const mod = new AppModule();
export default mod;
